import React, { useEffect, useState } from "react";
import AppModal from "../layout/app/AppModal";
import { onForegroundMessage } from "../../firebase/push";
import warningSound from "../../assets/sounds/warning.mp3";
import "../../assets/styles/app-notifications.css";

// What the popup shows for a message. Like the app, the heading and the
// device line come from words in the notification's title.
const popupFor = (payload) => {
  const notification = payload?.notification ?? {};
  const data = payload?.data ?? {};
  const title = notification.title ?? data.title ?? "";
  const lower = title.toLowerCase();
  return {
    title,
    message: notification.body ?? data.body ?? "",
    image: notification.image ?? data.image ?? data.imageUrl ?? "",
    heading: lower.includes("alert") ? "Alert" : lower.includes("warning") ? "Warning" : "Information",
    device: lower.includes("door sensor") ? "Door Sensor" : lower.includes("water level controller") ? "Water Level Controller" : null,
  };
};

// Browsers only play sound once the user has interacted with the page.
const playAlertSound = () => {
  new Audio(warningSound).play().catch(() => {});
};

// Push messages that arrive while the dashboard is open, shown as a popup
// with the alert sound. Ported from the app's NotificationWrapper
// (app/hooks/inAppNotification.js).
const InAppNotification = ({ children }) => {
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    let listening = true;
    let stop = () => {};
    onForegroundMessage((payload) => {
      setPopup(popupFor(payload));
      playAlertSound();
    }).then((unsubscribe) => {
      if (listening) stop = unsubscribe;
      else unsubscribe();
    });
    return () => {
      listening = false;
      stop();
    };
  }, []);

  const close = () => setPopup(null);

  return (
    <>
      {children}
      <AppModal open={Boolean(popup)} onClose={close} title={popup?.heading} className="hx-inapp">
        {popup ? (
          <div className="hx-inapp-body">
            {popup.device ? <div className="hx-inapp-device">{popup.device}</div> : null}
            <p className="hx-inapp-message">{popup.message}</p>
            {popup.image ? (
              <span className="hx-inapp-image">
                <img src={popup.image} alt="" />
              </span>
            ) : null}
            <div className="hx-inapp-title">{popup.title}</div>
            <button type="button" className="hx-inapp-dismiss" onClick={close}>
              Dismiss
            </button>
          </div>
        ) : null}
      </AppModal>
    </>
  );
};

export default InAppNotification;
